<template>
    <div
        class="p-3 flex items-center justify-center cursor-pointer overflow-visible"
        @click.stop="visible = !visible"
        :class="{
            relative: isRelative,
            'max-lg:': !isRelative,
        }"
    >
        <IconInfo class="tooltip-icon" />

        <div class="absolute transform-gpu transition-all z-50 tooltip" ref="tooltip" :class="[classes, [visible ? 'scale-100 opacity-100' : 'scale-0 opacity-0']]">
            <div
                class="block border-[10px] h-[20px] w-[20px] border-transparent grow-0 shrink-0"
                :class="{
                    'lg:border-r-black max-md:border-b-black max-md:mr-3': startPosition == 'right',
                    'lg:border-b-black max-md:border-b-black': startPosition == 'bottom',
                    'max-md:mr-[44px]': arrowOffsetMovedPosition !== false && startPosition == 'right',
                }"
            />

            <div class="bg-black text-grey-300 p-3 text-13 text-center z-10 min-w-[220px] h-fit relative">
                <template v-if="text !== false">{{ text }}</template>
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
import { onClickOutside } from '@vueuse/core'

export default {
    props: {
        text: { type: String, default: false },
        startPosition: { type: String, default: 'right' },
        isRelative: { type: Boolean, default: true },
        arrowOffsetMovedPosition: { type: [Boolean, String], default: false },
    },

    data() {
        return {
            visible: false,
            rightClass: ' ',
        }
    },

    mounted() {
        onClickOutside(this.$refs.tooltip, (event) => {
            if (this.visible) {
                setTimeout(() => {
                    this.visible = false
                }, 1)
            }
        })
    },

    computed: {
        classes() {
            switch (this.startPosition) {
                case 'right':
                    return 'left-[-1px] lg:left-[100%] max-md:top-[100%] max-md:right-[-1px] flex max-md:flex-col lg:items-center justify-center items-end lg:origin-left max-md:origin-top-right'
                    break
                case 'bottom':
                    return 'top-[100%] right-0'
                    break
            }
        },
    },
}
</script>
